import React from 'react'
import { FormDate, FormInput } from './FormInput'
import { CertificateData } from './Interfaces'

// Kendo components
import { Dialog } from '@progress/kendo-react-dialogs'
import { Form, FormElement } from '@progress/kendo-react-form'
import { RadioButton } from '@progress/kendo-react-inputs'

import styles from '.././EDIForms.module.scss'
import { AWCButton, BUTTON_TYPES } from '../../GlobalComponents/Inputs/Inputs'

export const AddCertificateModal: React.FC<{
    certificateData?: CertificateData
    certificateType: string
    expirationDate: string
    partnerOrSigning: string
    addCertificateError: string | null
    cancelModal: () => void
    onSubmit: (event: any) => void
    handleCertificateTypeChange: (event: any) => void
    handleExpirationDateChange: (event: any) => void
    handlePartnerOrSigningChange: (event: any) => void
}> = (props) => {
    return (
        <Dialog style={{ minWidth: 1000 }}>
            {props.certificateData && (
                <Form
                    onSubmitClick={props.onSubmit}
                    initialValues={props.certificateData}
                    render={(formRenderProps) => {
                        const dateValue = new Date(props.expirationDate)

                        return (
                            <FormElement>
                                <div className={styles.wrapHeader}>
                                    <div className={`k-form-buttons ${styles.buttonLeft}`}>
                                        <AWCButton
                                            type={BUTTON_TYPES.PRIMARY}
                                            onClick={formRenderProps.onSubmit}
                                            style={{
                                                width: 120,
                                            }}
                                        >
                                            Add Certificate
                                        </AWCButton>
                                    </div>
                                    <div className={`k-form-buttons ${styles.buttonRight}`}>
                                        <AWCButton
                                            type={BUTTON_TYPES.SECONDARY}
                                            onClick={props.cancelModal}
                                            style={{ width: 50 }}
                                        >
                                            <span className="k-icon k-i-close"></span>
                                        </AWCButton>
                                    </div>
                                </div>

                                <div className={styles.wrap}>
                                    <div>
                                        <FormInput
                                            length="short"
                                            label="File Name"
                                            name="CertificateFilename"
                                            maxChar={200}
                                            required={true}
                                        />
                                        {props.addCertificateError && (
                                            <div className={styles.error}>
                                                File name already exists!
                                            </div>
                                        )}
                                    </div>

                                    <FormDate
                                        label="Expiration Date"
                                        name="ExpirationDate"
                                        required={true}
                                        dateAsDate={dateValue}
                                        onDateChange={props.handleExpirationDateChange}
                                    />
                                </div>

                                <div
                                    className={styles.bolded}
                                    style={{
                                        textAlign: 'left',
                                        paddingTop: 15,
                                        paddingBottom: 10,
                                    }}
                                >
                                    Certificate Type
                                </div>

                                <div className={styles.wrap}>
                                    <RadioButton
                                        name="group1"
                                        value="PERSONAL"
                                        label="Personal"
                                        checked={props.certificateType === 'PERSONAL'}
                                        onChange={props.handleCertificateTypeChange}
                                    />
                                    <RadioButton
                                        name="group1"
                                        value="ROOT"
                                        label="Root"
                                        checked={props.certificateType === 'ROOT'}
                                        onChange={props.handleCertificateTypeChange}
                                    />
                                </div>

                                <div
                                    className={styles.bolded}
                                    style={{
                                        textAlign: 'left',
                                        paddingTop: 15,
                                        paddingBottom: 10,
                                    }}
                                >
                                    Partner or Signing
                                </div>

                                <div className={styles.wrap}>
                                    <RadioButton
                                        name="group2"
                                        value="PARTNER"
                                        label="Partner"
                                        checked={props.partnerOrSigning === 'PARTNER'}
                                        onChange={props.handlePartnerOrSigningChange}
                                    />
                                    <RadioButton
                                        name="group2"
                                        value="SIGNING"
                                        label="Signing"
                                        checked={props.partnerOrSigning === 'SIGNING'}
                                        onChange={props.handlePartnerOrSigningChange}
                                    />
                                </div>

                                <div className={styles.blockEnd} />
                            </FormElement>
                        )
                    }}
                />
            )}
        </Dialog>
    )
}
